import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-300 transition-all duration-300"
    >
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={article.image}
          alt={article.title}
          title={`${article.title} - 亚洲春色`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <span className="px-3 py-1 text-xs rounded-full bg-background-50/90 text-foreground-700 whitespace-nowrap">
            {article.category}
          </span>
        </div>
      </div>
      <div className="p-5">
        <h3 className="text-base font-semibold text-foreground-950 line-clamp-2 group-hover:text-primary-500 transition-colors leading-snug">
          {article.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
          <span>{article.author}</span>
          <span className="flex items-center gap-1">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-time-line text-xs"></i>
            </span>
            {article.readTime}
          </span>
        </div>
      </div>
    </Link>
  );
}